import { render } from "./userDashboard.vue?vue&type=template&id=9f8a1fa0&scoped=true"
import script from "./userDashboard.vue?vue&type=script&lang=js"
export * from "./userDashboard.vue?vue&type=script&lang=js"

import "./userDashboard.vue?vue&type=style&index=0&id=9f8a1fa0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\EZZKAH\\IdeaProjects\\datapark\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f8a1fa0"]])

export default __exports__